import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import SmartDataTable from "react-smart-data-table";
import "react-smart-data-table/dist/react-smart-data-table.css";
import "../../../css/admin.css";
import { GivenFlagss } from "../../../actions/auth";
import { useDispatch } from "react-redux";
import { MY_PROFILE } from "../../../actions/types";
import Pagination from "react-js-pagination";
const generateData = (givendflaglist = 0, numTransactResults = 0) => {
  let total = numTransactResults || 0;
  if (typeof numTransactResults === "string") {
    total = parseInt(numTransactResults, 10);
  }
  const GivenFlagTable = [];
  for (let i = 0; i < total; i += 1) {
    //   var a = i;
    GivenFlagTable.push({
      NameEmail:
        givendflaglist[i]?.givenFlag?.firstname +
        "--" +
        givendflaglist[i]?.givenFlag?.email +
        "--" +
        givendflaglist[i]?.givenFlag?.profile_image[0],
      transactionid: givendflaglist[i]?._id,
      datetime: givendflaglist[i]?.created_at,
    });
  }
  return GivenFlagTable;
};

export default function GivenFlagsData({ id }) {
  const dispatch = useDispatch();
  const [GivenFlagTable, setGivenFlagTable] = useState([]);
  const [numTransactResults, setNumTransactResults] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [searchVal, setSearchVal] = useState("");
  const [itemsPerPage, setItemsperpage] = useState(10);
  const [activePage, setActivePage] = useState(1);
  useEffect(async () => {
    await dispatch(GivenFlagss(id, searchVal)).then((res) => {
      // console.log("recived", res.data);

      setGivenFlagTable(generateData(res.data?.flags, res.data?.flags?.length));
      res && res.data && setNumTransactResults(res.data?.flags?.length);
      res && res.data && setTotalCount(res.data?.totalCount);
    });
  }, []);

  const HandleSearch = async (e) => {
    setSearchVal(e.target.value);
    await dispatch(GivenFlagss(id, e.target.value)).then((res) => {
      // console.log("recived", res.data);

      setGivenFlagTable(generateData(res.data?.flags, res.data?.flags?.length));
      res && res.data && setNumTransactResults(res.data?.flags?.length);
      res && res.data && setTotalCount(res.data?.totalCount);
    });
  };

  const handlePageChange = async (pagenumber) => {
    setActivePage(pagenumber);
    await dispatch(GivenFlagss(id, searchVal)).then((res) => {
      // console.log("recived", res.data);

      setGivenFlagTable(generateData(res.data?.flags, res.data?.flags?.length));
      res && res.data && setNumTransactResults(res.data?.flags?.length);
      res && res.data && setTotalCount(res.data?.totalCount);
    });
  };

  const calculateRange = () => {
    const currentPage = activePage;
    const itemsPerPage = 10;

    const startIndex = (currentPage - 1) * itemsPerPage + 1;

    let endIndex = currentPage * itemsPerPage;
    if (endIndex > totalCount) {
      endIndex = totalCount;
    }

    return `Showing ${startIndex} to ${endIndex} of ${totalCount} entries`;
  };

  const headers = {
    NameEmail: {
      text: "Name / Email",
      invisible: false,
      sortable: true,
      filterable: true,
      transform: (value, index, row) => {
        return (
          <>
            <ul className="p-0">
              <li className="d-flex">
                <Link to="#">
                  <img
                    alt=""
                    src={`${MY_PROFILE}/${value.split("--")[2]}`}
                    className="profilleeData"
                    onError={(e) => {
                      e.target.onerror = null; // Prevent infinite loop in case `noImage.png` also fails
                      e.target.src = "img/noImage.png"; // Fallback image if loading fails
                    }}
                  />
                </Link>
                <div className="ml-2">
                  <h5 className="clientName">
                    <Link to="#" className="clientName">
                      <b>{value.split("--")[0]}</b>
                    </Link>
                  </h5>
                  <p className="p-0">{value.split("--")[1]}</p>
                </div>
              </li>
            </ul>
          </>
        );
      },
    },

    transactionid: {
      text: "Flag ID",
      invisible: false,
      sortable: true,
      filterable: true,
      transform: (value, index, row) => {
        return (
          <>
            <p>{value ? value : "-"}</p>
          </>
        );
      },
    },
    datetime: {
      text: "Date and Time",
      invisible: false,
      sortable: true,
      filterable: true,
      transform: (value, index, row) => {
        return (
          <>
            <p>{value ? value : "-"}</p>
          </>
        );
      },
    },
    // action: {
    //   text: "Action",
    //   invisible: false,
    //   sortable: false,
    //   filterable: true,
    //   transform: (value, index, row) => {
    //     return (
    //       <>
    //         <Link to="#" className="edit-userbtn">
    //           <i className="far fa-times-circle"></i>
    //         </Link>
    //       </>
    //     );
    //   },
    // },
  };

  return (
    <>
      <div className="row pt-2 mt-3">
        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
          <div className="Search-Field">
            <label className="form-label fields-label">Search</label>
            <input
              type="search"
              className="form-control input-fields"
              id="searchbyevent"
              placeholder="By user name or email address"
              onChange={HandleSearch}
            />
            <i className="fas fa-search search-icon"></i>
          </div>
        </div>
      </div>
      <SmartDataTable
        data={GivenFlagTable}
        responsive={true}
        name="test-table"
        className="ui compact selectable table eventsDataTable"
        sortable
        headers={headers}
        emptyTable={<div className="text-center mt-2">No Records Found</div>}
      />

      <div className="d-flex justify-content-between  mt-3">
        <div className="my-records-number ">
          <p style={{ color: "#000" }}>{calculateRange()}</p>
        </div>
        <Pagination
          activePage={activePage}
          itemsCountPerPage={itemsPerPage}
          totalItemsCount={numTransactResults}
          pageRangeDisplayed={10}
          onChange={totalCount > itemsPerPage ? handlePageChange : null}
          itemClass="page-item"
          linkClass={
            totalCount && totalCount > 0 ? "page-link" : "page-link disabled"
          }
        />
      </div>
    </>
  );
}
